import { GridFooterType } from '@grid/enums';

export interface CellFooterConfig {
  type: GridFooterType;
  label?: string;
  // the digitsInfo parameter of Angular's number pipe (https://angular.io/api/common/DecimalPipe)
  format?: string;
  allowPercentage?: boolean;
}
